import { ModalHeaderProps } from 'components/Modal/Modal.types';
import CloseButton from 'components/Modal/partials/CloseButtonPrimaryVariant.component';
import React from 'react';
import breakpoints from 'style-utils/breakpoints';
import media from 'style-utils/media-queries';
import { H3 } from 'style/headings.style';
import styled, { StyledProps } from 'styled-components';

const ModalHeaderRoot = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  z-index: 3;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  background: var(--dialog-header);
  height: 50px;
  overflow: hidden;

  ${media.desktop`
    height: 60px;
  `};
`;

type ModalHeadingProps = StyledProps<{ center?: boolean }>;

const ModalHeading = styled(H3)<ModalHeadingProps>`
  display: block;
  margin: auto 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: ${({ theme }) => theme.modal.header.mobile.padding};
  ${({ center }) => (center ? 'text-align: center; padding: 0 50px;' : '')};
  color: var(--dialog-header-text);
  font-family: var(--secondary-font-family), sans-serif;
  font-size: 18px;
  line-height: 23px;
  font-weight: 600;

  @media (min-width: ${breakpoints.md}px) {
    padding: ${({ theme }) => theme.modal.header.tablet.padding};
  }

  ${media.desktop`
    padding: ${({ theme }: any) => theme.modal.header.desktop.padding};
    ${({ center }: ModalHeadingProps) => (center ? 'padding: 0 60px;' : '')};
  `};
`;

const ModalHeaderPrimaryVariant: React.FC<ModalHeaderProps> = ({
  onClose,
  heading,
  closeBtn = true,
  headingCenter,
}) => {
  return (
    <ModalHeaderRoot>
      {heading && <ModalHeading center={headingCenter}>{heading}</ModalHeading>}

      {closeBtn ? (
        <CloseButton
          data-qa="modal-close-button"
          onClick={onClose}
          iconSize={'16px'}
        />
      ) : null}
    </ModalHeaderRoot>
  );
};

export default ModalHeaderPrimaryVariant;
